import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, List } from 'antd';
import styled from 'styled-components';

const { Panel } = Collapse;

const TypologyRules = ({ typologies }) => {
  return (
    <StyledCollapse>
      <Panel header={`Variants (${typologies?.length || 0})`} key="1">
        <List
          size="medium"
          bordered={false}
          dataSource={typologies}
          renderItem={(item) => <StyledListItem>{item.title}</StyledListItem>}
        />
      </Panel>
    </StyledCollapse>
  );
};

const StyledCollapse = styled(Collapse)`
  &&& {
    border-radius: 4px;
    overflow: hidden;
    margin-top: 12px;
    .ant-collapse-header {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 11px;
      background: #eef4fa;
      padding: 8px 16px;
      .ant-collapse-arrow {
        margin-right: 8px;
      }
      svg {
        height: 10px;
        width: 10px;
      }
    }
    .ant-collapse-content-box {
      padding: 0px;
    }
  }
`;

const StyledListItem = styled(List.Item)`
  padding: 12px 24px;
  overflow-wrap: anywhere;
`;

TypologyRules.propTypes = {
  typologies: PropTypes.array
};

export default TypologyRules;
